import type { ReactNode } from 'react';
import { DialogIdentifier, type DialogConfiguration, type DialogService } from '@pixum/types';
import type { UploadErrorBaseProps } from '../../../types';
import { UploadErrorFileType } from '../partials/UploadErrorFileType';
import { UploadErrorFileTooSmall } from '../partials/UploadErrorFileTooSmall';
import { UploadErrorFileTooBig } from '../partials/UploadErrorFileTooBig';
import { UploadErrorResolutionTooBig } from '../partials/UploadErrorResolutionTooBig';
import { UploadErrorRetry } from '../partials/UploadErrorRetry';
import { UploadErrorFailedCompletely } from '../partials/UploadErrorFailedCompletely';

function toDialogConfig(dialog: (props: UploadErrorBaseProps) => ReactNode): DialogConfiguration {
  return { dialog: dialog as unknown as DialogConfiguration['dialog'] };
}

export function registerUploadErrorDialogs(dialogService: DialogService) {
  dialogService.registerDialog(DialogIdentifier.UPLOAD_ERROR_IMAGE_FILETYPE, toDialogConfig(UploadErrorFileType));
  dialogService.registerDialog(
    DialogIdentifier.UPLOAD_ERROR_IMAGE_FILE_TOO_SMALL,
    toDialogConfig(UploadErrorFileTooSmall)
  );
  dialogService.registerDialog(DialogIdentifier.UPLOAD_ERROR_IMAGE_FILE_TOO_BIG, toDialogConfig(UploadErrorFileTooBig));
  dialogService.registerDialog(
    DialogIdentifier.UPLOAD_ERROR_IMAGE_TOO_HIGH_RESOLUTION,
    toDialogConfig(UploadErrorResolutionTooBig)
  );
  dialogService.registerDialog(DialogIdentifier.UPLOAD_ERROR_RETRY, toDialogConfig(UploadErrorRetry));
  dialogService.registerDialog(
    DialogIdentifier.UPLOAD_ERROR_UPLOAD_FAILED_COMPLETELY,
    toDialogConfig(UploadErrorFailedCompletely)
  );
}
